import React, { useState, useEffect } from 'react';
import commonStyle from '../common.module.css';
import Topbar from '../../Components/TopBar/TopBar';
import { booleanObject, datesField, TASK_COLUMNS } from '../../Values/tables';
import { connect, useDispatch, useSelector } from 'react-redux';
import { fetchTasks } from '../../Services/contacts';
import {
  getFilterObject,
  searchTaskItem,
  filterTaskStatus,
} from '../../Values/utils';
import Loading from '../../Components/Loading/Loading';
import CustomTable from '../../Components/CustomTable/CustomTable';
import { getDateString, searchContacts } from '../../Values/utils';
import Cookies from 'universal-cookie';

import axios from 'axios';

import moment from 'moment';

import { localstorageKey, taskFilterValues, url } from '../../Values/constants';
import {
  setClearFilter,
  setFilterObject,
  setRefreshTasks,
  showSnackbarAction,
  // setTaskDrillDownClearFilter
} from '../../Redux/actions';
import ApiCustomTable from '../../Components/CustomTable/ApiCustomTable';
import ApiTopBar from '../../Components/TopBar/ApiTopBar';
import { themeColors } from '../../Components/theme';
import PopUpBox from "../AuditLogs/PopUpBox";
import { firestore } from '../../Firebase';
import axiosHandler from '../../Services/axiosHandler';
import { googleAnalytics } from '../../Services/users';

let isFinished = false;
const TaskDrilldown = ({
  history,
  user,
  branchUsers,
  filterObject,
  searchString,
  filterSort,
  refreshTasks,
  theme,
  authToken,
  organizationUsers
}: any) => {
  const [tasksList, setTasksList] = useState<any[] | undefined>(undefined);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [searchQuery, setsearchQuery] = useState('');
  const [status, setStatus] = useState('ALL');
  const [columnModal, setColumnModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [uidMap, setUidMap] = useState<any>();

  const [lastPage, setLastPage] = useState(-1);
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allTasks, setAllTasks] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>({});
  const [searchedItem, setsearchedItem] = useState('');
  const [drillRole, setDrillRole] = useState<any>({});
  const [filterApiCount, SetFilterApiCount] = useState<any>({});
  const [drillDownCount, SetDrillDownCount] = useState<any>({});
  const [showColumns, setShowColumns] = useState<any>(null); 
  const [isGACalled, setIsGACalled] = useState<any>(false);

  const dispatcher = useDispatch();
  const cookies = new Cookies();

  let userId = user.uid;

  const [localStorageData, setLocalStorageData] = useState<any>({});
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [userEmail, setUserEmail] = useState<any>(undefined);   
  let userName :string[] = [];
  const data: any[] = [];
  const fetchUserData = (()=>{
    const subscribe = firestore
        .collection('users')
        .where('organization_id', '==', user.organization_id)
        .onSnapshot((users) => {
          // const data: any[] = [];
          if (users) {
            users.forEach((users) => {
              data.push(users.data());
            });
            if (data) {
              let emailInfo: { [key: string]: string } = {};
              data.forEach((user: any) => {
                emailInfo[user.user_email]=user;
              });
              setUserEmail(emailInfo)
            }
          } 
        });
    })
  
    useEffect(() => {
      if(user.organization_id){
        fetchUserData()
      }
    }, [organizationUsers,user]);

  useEffect(() => {
    var key: any;
    const preserveLocalStorageFields = localstorageKey;
    for (var i = 0; i < localStorage.length; i++) {
      key = localStorage.key(i);

      if (!preserveLocalStorageFields.includes(key) && key !== 'columns' && key !== 'taskDrilldownData'  && key !== 'isLightMode' && key !== 'totalMonths' && key !== 'lastAlertTime') {
        localStorage.removeItem(key);
      }
    }

    dispatcher(setClearFilter(true));
    // dispatcher(setTaskDrillDownClearFilter(true));
    const savedData = localStorage.getItem('taskDrilldownData');
    if (savedData) {
      setLocalStorageData(JSON.parse(savedData));
    }
  }, [searchString]);
  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    } else {
      setLoad(true);
      const filters: { [key: string]: any[] } = { ...localStorageData.taskFilter };
      let feild;
      setDrillRole(localStorageData.role);
      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          filters[item] = filterObject[item];
        }
      });
      if (searchString === "") {
        feild = "contact_no";
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = "contact_no";
        } else {
          feild = "customer_name";
        }
      }
      let records = localPageSize ? localPageSize : pageSize;

      const { created_at, ...leadFilterObject } = localStorageData.leadFilter;
      const apiData = {
        uid: localStorageData.source === true && localStorageData.role === false ? user.uid : localStorageData.uid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: '-1' }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        taskFilter: localStorageData.source === true && localStorageData.role === false ? { ...filters, created_at, "source": [localStorageData.uid] } : { ...filters, created_at },
        leadFilter: leadFilterObject,
        role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,
        teamUids: localStorageData.teamUids ? localStorageData.teamUids : []
      };
      SetDrillDownCount(filters);
      SetFilterApiCount(apiData);
      try {
        // axios.defaults.headers.common['x-access-token'] =
        //   authToken
        const res = await axiosHandler.post(url + '/tasks/drillDownSearch', apiData);
        let data: any[] = res.data;
        if (data.length < records && paginate) {
          isFinished = true;
          setLastPage(page);
        }

        data.forEach((task) => {
          task.contactId = task.leadId;
          if (userEmail && userEmail[task.contact_owner_email]) {
            let info=userEmail[task.contact_owner_email];
            if(info){
              task.employee_id=info.employee_id?info.employee_id:"";
                if(info.user_first_name || info.user_last_name){
                  task.employee_name=info.user_first_name+" "+info.user_last_name;
                  userName.push(task.employee_name)
                }
            }
          }

          delete task['Id'];
          Object.keys(task).forEach((key) => {
            if (datesField.includes(key) && task[key] !== '') {
              if (task[key] !== null) {
                task[key] = moment(task[key]);
              } else {
                task[key] = '';
              }
            }
          });
        });
        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
          setLoad(false);
        } else {
          setFilterData(data);
          setLoad(false);
        }
      } catch {
        setFilterData([]);
        setLoad(false);
        // dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
      }
    }
  };

  useEffect(() => {
    if (localStorageData.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (userMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if(authToken){
      callApi(false, pageSize, 1);
    }
  }, [localStorageData, filterObject,authToken,userEmail,user]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if(authToken){
          callApi(false, pageSize);
        }
      } else {
        if(authToken){
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken,userEmail,user]);

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      setFilterData([]);
      return;
    }
    if(authToken){
      callCountApi();
    }
  }, [refreshTasks, user, drillDownCount, filterApiCount,authToken]);

  const callCountApi = async () => {
    const { page, pageSize, searchString, sort, ...objFilterData } = filterApiCount;
    // axios.defaults.headers.common['x-access-token'] =
    //   authToken
    const res = await axiosHandler.post(url + '/tasks/drillDownCount', objFilterData);
    setTotalCounts(res?.data[0]?.total);
  };
  useEffect(() => {
    if (refreshTasks === true) {
      if(authToken){
        callApi();
      getTasksFilter();
      dispatcher(setRefreshTasks(false));
      }
    }
  }, [refreshTasks,authToken,userEmail,user]);

  // useEffect(()=>{
  //   const storedValue = localStorage.getItem('taskShowFilterValues');
  //   setShowColumns(storedValue);
  //   getTasksFilter();
  // },[localStorage.getItem('taskShowFilterValues'),showColumns])

  const getTasksFilter = async () => {
    const res = await axiosHandler.post(url + '/tasks/filterValues', {
      // uid: user.uid,
      uid: localStorageData.source === true && localStorageData.role === false ? user.uid : localStorageData.uid,
      role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,
      teamUids: localStorageData.teamUids ? localStorageData.teamUids : [],
      showColumns:showColumns === null?taskFilterValues:JSON.parse(showColumns)
    });
    const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
      organization_id: user.organization_id,
      uid: user.uid,
      });
    if (res.data[0]) {
      dispatcher(setFilterObject({ ...res.data[0], ...booleanObject,'employee_name':userdetail.data.data.Employee_Name,'employee_id':userdetail.data.data.Employee_id}));
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    const storedValue = localStorage.getItem('taskShowFilterValues');
    setShowColumns(storedValue);
    if (user === undefined || user.uid === undefined) {
      return;
    }
    if(authToken){
      getTasksFilter();
    }
  }, [user,authToken,localStorage.getItem('taskShowFilterValues'),showColumns]);

  const exportFile = () => {
    let data: any[] = [];
    if (selectedRowsData.length === 0) {
    } else {
      selectedRowsData.forEach((item,index) => {
        data.push(
          {
            // "Id": item?._id,
            // "LeadId":item?.leadId ,
            "S.NO":index+1,
            "Customer Name": item?.customer_name,
            "Task Type": item?.type,
            "Lead Assignee Email":item?.contact_owner_email,
            "Lead Stage":item?.stage,
            "Project": item?.project,
            "Location": item?.location,
            "Budget": item?.budget,
            "Contact Number": item?.contact_no,
            "Inventory Type":item?.inventory_type,
            "Lead Source":item?.source,
            "Transfer Status": item?.transfer_status,
            "Due On":getDateString(item?.due_date),
            "Completed On":getDateString(item?.completed_at),
            "Call Back Reason":item?.call_back_reason,
            "Status": item?.status,
            "Created By":item?.created_by,
            "Created On":getDateString(item?.created_at),
            // "uid": item?.uid,
            // "OrganizationId":item?.organization_id,
            // "V": item?.__v,
            // "ContactId": item?.contactId
            "Employee ID":item.employee_id,
            "Lead Assignee": item.employee_name,
            'Lead State': item.state,
          }
        );
      });
    }

    return data;
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Task_DrillDown_Screen',user)
      }
    }
  },[user])

  return (
    <div style={{ height: "100vh", ...containerStyles }}>
      <div className={commonStyle.topBar} style={containerStyles}>
        <ApiTopBar
          history={history}
          title={'Add Task'}
          path={'/addTasks'}
          onClick={() => {
            setShowImportModal(true);
          }}
          onChange={(val) => setsearchedItem(val)}
          filterText={'Status'}
          setColumnModal={(data) => setColumnModal(data)}
          show={true}
          showStatusBox={false}
          onExport={exportFile}
          searchedString={searchString}
          titleDrillDown={'Drill Down'}
          selectedRows={selectedRows}
            setAuditLog={setAuditLog}
            isOtpVerified={isOtpVerified}
            panel = "tasks drilldown"
        />
      </div>
      <div className={commonStyle.parent} style={{ height: "81%", ...containerStyles }}>
        {load === true && <Loading />}

        <ApiCustomTable
          tableColumns={TASK_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="Task"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setPage={(val) => setPage(val)}
          setPageSize={(val) => setPageSize(val)}
          callApi={callApi}
          pageSize={pageSize}
          page={page}
          isFinished={isFinished}
          totalCount={totalCounts}
          lastPage={lastPage}
          DrillDownpanel = "tasks drilldown"
        />
         {auditLog && (
              <PopUpBox
                open={auditLog}
                close={() => setAuditLog(false)}
                setIsOtpVerified={setIsOtpVerified}
                setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "tasks drilldown"
              />)}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    branchUsers: state.branchUsers.data,
    // filterObject: state.filter,
    // filterSort: state.filterSort,
    filterObject: state.TaskDrillDownFilter,
    filterSort: state.taskDrillDownfilterSort,
    searchString: state.searchItem.tasksSearchString,
    refreshTasks: state.refresh.refreshTasks,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationUsers: state.organizationUsers.data,
  };
};

export default connect(mapStateToProps)(TaskDrilldown);
